import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';

@Component({
  selector: 'app-error-page-message',
  templateUrl: './error-page-message.component.html',
  styleUrls: ['./error-page-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorPageMessageComponent {
  @Input() public icon: CustomIcons = CustomIcons.Page404;
  @Input() public header = 'APP_ERROR_MESSAGE.TITLE';
  @Input() public message = 'APP_ERROR_MESSAGE.PAGE_NOT_FOUND';
  @Input() public maxWidth = 300;
}
